import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
import AdGrid from '../components/AdGrid';
import AdDetailPanel from '../components/AdDetailPanel';
import { useData } from '../context/DataContext';
import { toast } from 'sonner';

const FavoritesPage = () => {
  const { ads, loading, fetchAds, updateAd, deleteAd } = useData();
  const [selectedAd, setSelectedAd] = useState(null);
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  useEffect(() => {
    fetchAds({ favorites: true });
  }, [fetchAds]);

  const handleAdClick = (ad) => {
    setSelectedAd(ad);
    setIsPanelOpen(true);
  };

  const handleToggleFavorite = async (ad) => {
    try {
      await updateAd(ad.id, { is_favorite: !ad.is_favorite });
      fetchAds({ favorites: true });
      toast.success('Removed from favorites');
    } catch (err) {
      toast.error('Failed to update');
    }
  };

  const handleDelete = async (ad) => {
    if (window.confirm('Delete this ad?')) {
      try {
        await deleteAd(ad.id);
        toast.success('Ad deleted');
      } catch (err) {
        toast.error('Failed to delete');
      }
    }
  };

  return (
    <div className="min-h-screen" data-testid="favorites-page">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <Heart className="w-7 h-7 text-red-400 fill-red-400" />
          <h1 className="text-2xl md:text-3xl font-bold text-white">Favorites</h1>
        </div>
        <p className="text-zinc-500">Your saved favorite ads</p>
      </div>

      <AdGrid
        ads={ads}
        loading={loading}
        onAdClick={handleAdClick}
        onToggleFavorite={handleToggleFavorite}
        onDelete={handleDelete}
      />

      <AdDetailPanel
        ad={selectedAd}
        open={isPanelOpen}
        onClose={() => {
          setIsPanelOpen(false);
          setSelectedAd(null);
        }}
      />
    </div>
  );
};

export default FavoritesPage;
